








import { Vue, Component } from "vue-property-decorator";
import QHeader from "./qHeader.vue";
import QFooter from "./qFooter.vue";

@Component({
  name: "CommonLayout",
  components: {
    QHeader,
    QFooter,
  },
})
export default class CommonLayout extends Vue {}
